import { useDispatch, useSelector } from 'react-redux';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import './css/mobile.css';
import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle, setMyData } from '../store';
import axios from 'axios';
import { LoadingModal, MessageModal } from './component/modal/modal';
import { getImageSrc } from './common/function';

/** 카카오(다음) 우편번호 스크립트 로더 */
function loadDaumPostcode() {
    const SCRIPT_ID = 'daum-postcode-script';
    return new Promise((resolve, reject) => {
        if (window.daum?.Postcode) return resolve(true);
        if (document.getElementById(SCRIPT_ID)) {
            const check = setInterval(() => {
                if (window.daum?.Postcode) {
                    clearInterval(check);
                    resolve(true);
                }
            }, 50);
            setTimeout(() => {
                clearInterval(check);
                if (window.daum?.Postcode) resolve(true);
                else reject(new Error('Daum Postcode load timeout'));
            }, 5000);
            return;
        }
        const s = document.createElement('script');
        s.id = SCRIPT_ID;
        s.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
        s.async = true;
        s.onload = () => resolve(true);
        s.onerror = () => reject(new Error('Daum Postcode script failed'));
        document.head.appendChild(s);
    });
}

function UrlPayment() {
    const dispatch = useDispatch();
    const hostLogoImg = useSelector((state) => state.hostLogoImg.value);
    const MyData = useSelector((state) => state.MyData);

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState({ msg: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [listData, setListData] = useState([]);
    const [dataParam, setDataParam] = useState("");

    // ------- UrlDetail에서 넘어온 값 수신 -------
    const { state: passed } = useLocation(); // { product, quantity, unitPrice, amount }

    // 폼 데이터(자동 채움)
    const [formData, setFormData] = useState({
        MerchantName: "",
        GoodsName: "",
        GoodsCode: "",
        Amt: "",              // 숫자만 (총액)

        BuyerName: "",
        BuyerAddr: "",        // 서버 전송용(아래 Base/Extra/Detail 합쳐 자동세팅)
        BuyerEmail: "",
        BuyerHpTel: "",

        // 주소 세부
        Postcode: "",
        BaseAddr: "",         // 도로명/지번 기본주소
        ExtraAddr: "",        // 참고항목(동/건물명) - 자동 생성
        DetailAddr: "",       // 상세주소(사용자 입력)

        quantity: "1",
        PaymentMethod: "00",
        CashReceiptType: "0",
        CashReceiptInfo: "",
        
        // 카드 정보 (PASS인증 결제용)
        card_num: "",      // 카드번호 (숫자만) - 4개 input을 합쳐 저장
        CardCvv: "",      // CVV
        CardPw: "",        // 카드 비밀번호 앞 2자리
        ExpMonth: "",     // 유효기간 월
        ExpYear: "",      // 유효기간 년
        CardQuota: "00",  // 할부 개월수
        IDNo: "",         // 주민등록번호 (본인인증용)
    });

    // 옵션 관련 상태
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedQuantity, setSelectedQuantity] = useState(1);
    const [productData, setProductData] = useState(null);

    const [displayAmt, setDisplayAmt] = useState(""); // 콤마 포함 보여주기용
    const [phoneDisplayValue, setPhoneDisplayValue] = useState("");
    const [saveNextTime, setSaveNextTime] = useState(true);

    // 카드번호를 4개 input으로 분할해서 관리
    const [cardNum1, setCardNum1] = useState("");
    const [cardNum2, setCardNum2] = useState("");
    const [cardNum3, setCardNum3] = useState("");
    const [cardNum4, setCardNum4] = useState("");
    const cardNum2Ref = useRef(null);
    const cardNum3Ref = useRef(null);
    const cardNum4Ref = useRef(null);

    const navigate = useNavigate();
    const modalBodyRef = useRef(null);
    const passAuthPopupRef = useRef(null); // PASS인증 팝업 참조
    const fmt = (n) => (typeof n === "number" ? n.toLocaleString("ko-KR") : n);

    // ===== 주소검색 모달 관련 =====
    const [addrOpen, setAddrOpen] = useState(false);
    const addrLayerRef = useRef(null);
    const detailInputRef = useRef(null);

    useEffect(() => {
        if (addrOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = '';
        return () => { document.body.style.overflow = ''; };
    }, [addrOpen]);

    const openAddressSearch = async () => {
        try {
            await loadDaumPostcode();
            setAddrOpen(true);
            setTimeout(() => {
                const bodyEl = modalBodyRef.current;
                const wrapEl = addrLayerRef.current;
                if (!bodyEl || !wrapEl) return;

                // 바디 높이에 래퍼 높이를 맞춰주면 내부가 자연스럽게 스크롤됨
                const applyHeight = () => {
                    wrapEl.style.height = `${bodyEl.clientHeight}px`;
                };
                applyHeight();

                wrapEl.innerHTML = "";
                new window.daum.Postcode({
                    oncomplete: (data) => {
                        // 주소 데이터 처리
                        let addr = '';
                        let extraAddr = '';

                        // 사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
                        if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
                            addr = data.roadAddress;
                        } else { // 사용자가 지번 주소를 선택했을 경우(J)
                            addr = data.jibunAddress;
                        }

                        // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
                        if (data.userSelectedType === 'R') {
                            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                            if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
                                extraAddr += data.bname;
                            }
                            // 건물명이 있고, 공동주택일 경우 추가한다.
                            if (data.buildingName !== '' && data.apartment === 'Y') {
                                extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
                            }
                            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                            if (extraAddr !== '') {
                                extraAddr = ' (' + extraAddr + ')';
                            }
                        }

                        // 우편번호와 주소 정보를 해당 필드에 넣는다.
                        setFormData(prev => ({
                            ...prev,
                            Postcode: data.zonecode,
                            BaseAddr: addr,
                            ExtraAddr: extraAddr
                        }));

                        // 커서를 상세주소 필드로 이동한다.
                        if (detailInputRef.current) {
                            detailInputRef.current.focus();
                        }

                        // 주소 검색 모달 닫기
                        setAddrOpen(false);
                    },
                    onresize: () => {
                        // iOS Safari 대응: 바디 높이에 계속 맞춰줌
                        applyHeight();
                    },
                    width: '100%',
                    height: '100%',
                    maxSuggestItems: 5
                }).embed(wrapEl);
            }, 0);
        } catch (e) {
            console.error(e);
            setMessage({ msg: "주소 검색 스크립트 로딩에 실패했습니다." });
        }
    };

    // 초기 진입 세팅
    useEffect(() => {
        dispatch(change_Current_Location("URL상품결제"));
        dispatch(changeHeaderTitle({ mainTitle: "URL상품결제", subTitle: "" }));
        const t = setTimeout(() => setLoading(false), 300);
        return () => clearTimeout(t);
    }, [dispatch]);

    // UrlDetail state → 자동 채움 (기존 방식 유지)
    const unit = passed?.unitPrice ?? 0;
    const qtyFromState = passed?.quantity ?? 1;
    const totalFromState = passed?.amount ?? unit * qtyFromState;
    const prod = passed?.product || {};
    const prodImg = prod?.heroImages?.[0] || ""; // ✅ 썸네일
    const originalUnit = prod?.listPrice ?? unit;
    const showOriginal = Number(originalUnit) > Number(unit);

    useEffect(() => {
        if (!passed) return;
        setFormData((prev) => ({
            ...prev,
            MerchantName: prod.brand || prev.MerchantName,   // 가맹점=브랜드 기준
            GoodsName: prod.title || prev.GoodsName,
            GoodsCode: prod.modelName || prev.GoodsCode,
            quantity: String(qtyFromState),
            Amt: String(totalFromState),
        }));
        setDisplayAmt(fmt(totalFromState));
    }, [passed]); // eslint-disable-line

    // URL 파라미터에서 type 값 추출
    const [paymentType, setPaymentType] = useState(null);
    
    // (옵션) URL 쿼리로 불러온 데이터도 지원 (state 없을 때만)
    useEffect(() => {
        if (passed) return;
        const params = new URLSearchParams(window.location.search);
        const value = params.get("data") || "";
        const type = params.get("type") || null;
        setDataParam(value);
        setPaymentType(type);
        if (!value) return;
        (async () => {
            try {
                const res = await axios.get(
                    process.env.REACT_APP_API + "/api/url-pay",
                    { params: { data: value } }
                );
                const tmp = res?.data;
                if (tmp?.code === 1000) {
                    const d = tmp?.data ?? {};
                    setProductData(d);
                    setListData(d);
                    
                    // 재고 있는 첫 번째 옵션을 기본 선택으로 설정
                    if (d?.options && d.options.length > 0) {
                        const firstInStock = d.options.find(opt => (opt.stockQuantity ?? 0) > 0) ?? d.options[0];
                        setSelectedOption(firstInStock);
                        setSelectedQuantity(1);
                        
                        // 기본 가격 계산 (할인가 적용 + 옵션 추가 가격 + 배송비)
                        const basePrice = d?.is_discount_active && d?.discount_price 
                            ? Number(d.discount_price) 
                            : Number(d.price) || 0;
                        const optionPrice = Number(firstInStock.additionalPrice) || 0;
                        const productSubtotal = (basePrice + optionPrice) * 1;
                        const minFreeShipping = Number(d?.free_shipping_min_amount) || 0;
                        const baseShippingFee = Number(d?.shipping_fee) || 0;
                        const shippingFee = (minFreeShipping === 0 || productSubtotal >= minFreeShipping) ? 0 : baseShippingFee;
                        const totalPrice = productSubtotal + shippingFee;
                        
                        setFormData((prev) => ({
                            ...prev,
                            MerchantName: d?.co_nm ?? "",
                            GoodsName: d?.product_name ?? "",
                            GoodsCode: d?.product_code ?? "",
                            quantity: "1",
                            Amt: String(totalPrice),
                        }));
                        setDisplayAmt(fmt(totalPrice));
                    } else {
                        // 옵션이 없는 경우 기본 가격 + 배송비로 설정
                        const basePrice = Number(d.price) || 0;
                        const productSubtotal = basePrice;
                        const minFreeShipping = Number(d?.free_shipping_min_amount) || 0;
                        const baseShippingFee = Number(d?.shipping_fee) || 0;
                        const shippingFee = (minFreeShipping === 0 || productSubtotal >= minFreeShipping) ? 0 : baseShippingFee;
                        const totalPrice = productSubtotal + shippingFee;
                        setFormData((prev) => ({
                            ...prev,
                            MerchantName: d?.co_nm ?? "",
                            GoodsName: d?.product_name ?? "",
                            GoodsCode: d?.product_code ?? "",
                            quantity: "1",
                            Amt: String(totalPrice),
                        }));
                        setDisplayAmt(fmt(totalPrice));
                    }
                } else if (tmp?.code === 9999) {
                    navigate("/");
                }
            } catch (e) {
                console.error(e);
                navigate("/");
            }
        })();
    }, [passed, navigate]);

    // 입력 핸들러들
    const handlePhoneChange = (e) => {
        let numeric = e.target.value.replace(/\D/g, "").slice(0, 11);
        const parts =
            numeric.length < 4
                ? [numeric]
                : numeric.length < 8
                    ? [numeric.slice(0, 3), numeric.slice(3)]
                    : [numeric.slice(0, 3), numeric.slice(3, 7), numeric.slice(7)];
        const displayVal = parts.join("-");
        setPhoneDisplayValue(displayVal);
        setFormData((prev) => ({ ...prev, BuyerHpTel: numeric }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // 카드번호 입력 핸들러 (4개 필드)
    const handleCardInput1 = (e) => {
        let val = e.target.value.replace(/\D/g, "");
        val = val.slice(0, 4);
        setCardNum1(val);
        if (val.length === 4) {
            cardNum2Ref.current?.focus();
        }
    };

    const handleCardInput2 = (e) => {
        let val = e.target.value.replace(/\D/g, "");
        val = val.slice(0, 4);
        setCardNum2(val);
        if (val.length === 4) {
            cardNum3Ref.current?.focus();
        }
    };

    const handleCardInput3 = (e) => {
        let val = e.target.value.replace(/\D/g, "");
        val = val.slice(0, 4);
        setCardNum3(val);
        if (val.length === 4) {
            cardNum4Ref.current?.focus();
        }
    };

    const handleCardInput4 = (e) => {
        let val = e.target.value.replace(/\D/g, "");
        val = val.slice(0, 4);
        setCardNum4(val);
    };

    // 카드번호 4개의 상태가 변할 때마다 formData.card_num에 합쳐서 저장
    useEffect(() => {
        const combined = cardNum1 + cardNum2 + cardNum3 + cardNum4;
        setFormData((prev) => ({
            ...prev,
            card_num: combined, // 숫자만
        }));
    }, [cardNum1, cardNum2, cardNum3, cardNum4]);

    // 가격 업데이트 함수 (free_shipping_min_amount: 이 금액 이상이면 배송비 무료)
    const updatePrice = (quantity) => {
        if (!productData) return;
        
        const basePrice = productData?.is_discount_active && productData?.discount_price 
            ? Number(productData.discount_price) 
            : Number(productData.price) || 0;
        const optionPrice = Number(selectedOption?.additionalPrice) || 0;
        const productSubtotal = (basePrice + optionPrice) * quantity;
        const minFreeShipping = Number(productData?.free_shipping_min_amount) || 0;
        const baseShippingFee = Number(productData?.shipping_fee) || 0;
        const shippingFee = (minFreeShipping === 0 || productSubtotal >= minFreeShipping) ? 0 : baseShippingFee;
        const totalPrice = productSubtotal + shippingFee;
        
        setFormData(prev => ({
            ...prev,
            Amt: String(totalPrice),
            quantity: String(quantity)
        }));
        setDisplayAmt(fmt(totalPrice));
    };

    // 현재 주문 기준 적용 배송비 (free_shipping_min_amount 반영, 표시용)
    const effectiveShippingFee = (() => {
        if (!productData) return 0;
        const basePrice = productData?.is_discount_active && productData?.discount_price
            ? Number(productData.discount_price)
            : Number(productData.price) || 0;
        const optionPrice = Number(selectedOption?.additionalPrice) || 0;
        const productSubtotal = (basePrice + optionPrice) * selectedQuantity;
        const minFreeShipping = Number(productData?.free_shipping_min_amount) || 0;
        const baseShippingFee = Number(productData?.shipping_fee) || 0;
        return (minFreeShipping === 0 || productSubtotal >= minFreeShipping) ? 0 : baseShippingFee;
    })();

    // Base/Extra/Detail → BuyerAddr 자동 결합
    useEffect(() => {
        const combined = [formData.BaseAddr, formData.ExtraAddr, formData.DetailAddr]
            .filter(Boolean)
            .join(' ')
            .trim();
        if (combined !== formData.BuyerAddr) {
            setFormData((prev) => ({ ...prev, BuyerAddr: combined }));
        }
    }, [formData.BaseAddr, formData.ExtraAddr, formData.DetailAddr]); // eslint-disable-line

    // 필수값 체크(비어있으면 버튼 비활성화)
    const requiredFilled =
        (formData.BuyerName || "").trim() !== "" &&
        (formData.BaseAddr || "").trim() !== "" &&    // 주소는 기본주소 기준
        (formData.BuyerEmail || "").trim() !== "" &&
        (formData.Postcode || "").trim() !== "" &&
        String(formData.BuyerHpTel || "").trim() !== "";

    const isDisabled = isSubmitting || !requiredFilled;

    // 결제 요청
    const onSubmitPayment = async () => {
        if (isDisabled) return;
        setIsSubmitting(true);
        setLoading(true);
        
        try {
            // type에 따른 분기 처리
            if (paymentType === 'a') {
                // type=a: PASS인증 방식의 결제 API 호출
                await handlePassPayment();
            } else {
                // type=b 또는 type이 없는 경우: 기존 프로세스
                await handleNormalPayment();
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
            setIsSubmitting(false);
            const apiMsg = error?.response?.data?.msg || error?.message;
            setMessage({ msg: apiMsg ? `오류: ${apiMsg}` : "결제 요청 중 오류가 발생했습니다." });
        }
    };

    // 기존 결제 프로세스 (type=b 또는 type 없음)
    const handleNormalPayment = async () => {
        const response = await axios.post(
            process.env.REACT_APP_API + "/api/url-pay",
            {
                data: dataParam,
                userAddress: formData.BuyerAddr,
                ordNm: formData.BuyerName,
                email: formData.BuyerEmail,
                quantity: formData.quantity,
                tel: formData.BuyerHpTel,
                cashReceipt: formData.CashReceiptType,
                cashReceiptInfo: formData.CashReceiptInfo,
                saveNextTime,
                product: passed?.product,
                unitPrice: unit,
                amount: Number(formData.Amt || 0),
                postcode: formData.Postcode,
                baseAddr: formData.BaseAddr,
                detailAddr: formData.DetailAddr,
                selectedOptionId: selectedOption?.optionId ?? null,
            },
            {}
        );
        const tmp = response?.data;

        if (tmp?.code < 2000) {
            onSubmitPaymentModal(tmp?.data?.header, tmp?.data?.body)
        } else {
            setLoading(false);
            setIsSubmitting(false);
            setMessage({ msg: "결제실패" });
        }
    };

    // PASS인증 방식 결제 프로세스 (type=a)
    const handlePassPayment = async () => {
        try {
            setLoading(true);
            setIsSubmitting(true);
            
            // 결제 정보 수집
            const amt = Number(formData.Amt) || 0;
            const quantity = Number(formData.quantity) || selectedQuantity || 1;
            const unitPrice = quantity > 0 ? Math.floor(amt / quantity) : amt;
            
            // payment_id 생성 (임시 ID, 서버에서 재생성 가능)
            const paymentId = `PAY_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            
            // 본인인증 시작 요청 (결제 정보 포함)
            const authResponse = await axios.post(
                process.env.REACT_APP_API + "/api/identity/start",
                {
                    returnURL: process.env.REACT_APP_API + "/api/identity/checkplus_success",
                    payment_id: paymentId,
                    user_address: formData.BuyerAddr || "",
                    tel: formData.BuyerHpTel || "",
                    payment_data: {
                        mid: MyData.mid || "",
                        amt: amt,
                        goods_name: formData.GoodsName || productData?.product_name || "",
                        ord_nm: formData.BuyerName || "",
                        email: formData.BuyerEmail || "",
                        product_code: formData.GoodsCode || productData?.product_code || "",
                        quantity: quantity,
                        unit_price: unitPrice,
                        tmn_id: MyData.tmn_id || "",
                        pay_method: formData.PaymentMethod || "00",
                        // 카드 정보
                        cardNumber: formData.card_num || "",
                        cardExpiry: (formData.ExpYear || "") + (formData.ExpMonth || ""),
                        cardCvv: formData.CardCvv || "",
                        cardPw: formData.CardPw || "",
                        installment: formData.CardQuota || "00"
                    }
                },
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );
            


            if (authResponse.data.success && authResponse.data.data) {
                const { req_no, token_version_id, enc_data, integrity, auth_url } = authResponse.data.data;
                
                // req_no 저장 (인증 결과 조회용)
                if (req_no) {
                    localStorage.setItem('identity_req_no', req_no);
                    // 결제 정보 저장 (카드 민감정보 제외)
                    const { card_num, CardCvv, CardPw, IDNo, ...safeFormData } = formData;
                    localStorage.setItem('identity_payment_data', JSON.stringify({
                        formData: safeFormData,
                        productData,
                        listData
                    }));
                }
                
                // 필수 데이터 확인
                if (!token_version_id || !enc_data || !integrity) {
                    setLoading(false);
                    setIsSubmitting(false);
                    setMessage({ msg: "본인인증 데이터가 올바르지 않습니다." });
                    return;
                }
                
                // NICE CheckPlus 본인인증 팝업 생성 (빈 팝업 먼저 열기)1
                const popupWindow = window.open(
                    '',
                    'popupChk',
                    'width=480, height=812, top=100, fullscreen=no, menubar=no, status=no, titlebar=yes, location=no, toolbar=no, scrollbar=no'
                );

                if (!popupWindow) {
                    alert("팝업이 차단되었습니다. 팝업 차단을 해제해주세요.");
                    setLoading(false);
                    setIsSubmitting(false);
                    return;
                }

                // 팝업 참조 저장
                passAuthPopupRef.current = popupWindow;

                // NICE CheckPlus 본인인증 폼 생성
                const form = document.createElement('form');
                form.name = 'form_chk';
                form.method = 'post';
                form.action = process.env.REACT_APP_NICE_AUTH_URL;
                form.target = 'popupChk';
                form.style.display = 'none';

                // NICE CheckPlus 필수 필드들 추가
                const formFields = {
                    'm': 'service',
                    'token_version_id': token_version_id,
                    'enc_data': enc_data,
                    'integrity_value': integrity
                };

                // 폼 필드들을 추가
                Object.keys(formFields).forEach(key => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = formFields[key];
                    form.appendChild(input);
                });

                // 폼을 body에 추가하고 제출
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);

                // 팝업 닫힘 감지 및 결과 처리
                const checkClosed = setInterval(() => {
                    if (popupWindow.closed) {
                        clearInterval(checkClosed);
                        // 팝업이 닫히면 폴링 시작
                        if (req_no) {
                            setLoading(true);
                            pollAuthResult(req_no);
                        }
                    }
                }, 1000);

                // 5분 후 자동 타임아웃
                setTimeout(() => {
                    if (!popupWindow.closed) {
                        popupWindow.close();
                        clearInterval(checkClosed);
                        setLoading(false);
                        setIsSubmitting(false);
                        setMessage({ msg: "PASS인증 시간이 초과되었습니다." });
                        localStorage.removeItem('identity_req_no');
                        localStorage.removeItem('identity_payment_data');
                    }
                }, 300000);
            } else {
                setLoading(false);
                setIsSubmitting(false);
                setMessage({ msg: authResponse.data.message || "본인인증 데이터 생성에 실패했습니다." });
            }
        } catch (error) {
            console.error("PASS인증 요청 오류:", error);
            setLoading(false);
            setIsSubmitting(false);
            setMessage({ msg: "PASS인증 요청 중 오류가 발생했습니다." });
        }
    };

    // PASS인증 결과 조회 (폴링)
    const pollAuthResult = async (requestNo) => {
        if (!requestNo) {
            setLoading(false);
            setIsSubmitting(false);
            return;
        }

        const maxAttempts = 60; // 최대 60번 시도 (약 2분)
        let attempts = 0;
        const pollInterval = 2000; // 2초마다 조회

        const poll = async () => {
            try {
                const response = await axios.get(
                    process.env.REACT_APP_API + `/api/identity/result?req_no=${requestNo}`
                );

                const result = response.data;


                if (result.success && result.status === 'completed') {
                    // 인증 성공 - 결제 완료
                    const savedPaymentData = localStorage.getItem('identity_payment_data');
                    let paymentFormData = formData;
                    let paymentProductData = productData;
                    let paymentListData = listData;

                    if (savedPaymentData) {
                        try {
                            const parsed = JSON.parse(savedPaymentData);
                            // localStorage(민감정보 제외)와 React state(카드 데이터 포함)를 병합
                            paymentFormData = { ...formData, ...(parsed.formData || {}) };
                            paymentProductData = parsed.productData || productData;
                            paymentListData = parsed.listData || listData;
                        } catch (e) {
                            console.error("저장된 결제 데이터 파싱 오류:", e);
                        }
                    }

                    // 팝업이 열려있으면 닫기
                    if (passAuthPopupRef.current && !passAuthPopupRef.current.closed) {
                        passAuthPopupRef.current.close();
                        passAuthPopupRef.current = null;
                    }

                    // localStorage 정리
                    localStorage.removeItem('identity_req_no');
                    localStorage.removeItem('identity_payment_data');

                    setLoading(false);
                    setIsSubmitting(false);
                    
                    navigate("/urlComplete", {
                        state: {
                            receipt: { 
                                success: true, 
                                paymentType: 'pass',
                                authData: result.data
                            },
                            listData: paymentListData,
                        },
                        replace: false,
                    });
                    return;
                } else if (result.status === 'pending') {
                    // 아직 완료되지 않음 - 다시 시도
                    attempts++;
                    if (attempts < maxAttempts) {
                        setTimeout(poll, pollInterval);
                    } else {
                        setLoading(false);
                        setIsSubmitting(false);
                        setMessage({ msg: "인증 결과 조회 시간이 초과되었습니다." });
                        localStorage.removeItem('identity_req_no');
                        localStorage.removeItem('identity_payment_data');
                    }
                } else if (result.status === 'expired') {
                    // 만료됨
                    setLoading(false);
                    setIsSubmitting(false);
                    setMessage({ msg: "인증 결과가 만료되었습니다. 다시 시도해주세요." });
                    localStorage.removeItem('identity_req_no');
                    localStorage.removeItem('identity_payment_data');
                } else {
                    // 인증 실패
                    setLoading(false);
                    setIsSubmitting(false);
                    setMessage({ msg: result.message || "본인인증에 실패했습니다." });
                    localStorage.removeItem('identity_req_no');
                    localStorage.removeItem('identity_payment_data');
                }
            } catch (error) {
                console.error("인증 결과 조회 오류:", error);
                attempts++;
                if (attempts < maxAttempts) {
                    setTimeout(poll, pollInterval);
                } else {
                    setLoading(false);
                    setIsSubmitting(false);
                    setMessage({ msg: "인증 결과 조회 중 오류가 발생했습니다." });
                    localStorage.removeItem('identity_req_no');
                    localStorage.removeItem('identity_payment_data');
                }
            }
        };

        poll();
    };

    const onSubmitPaymentModal = async (header, body) => {
        // 모바일 판별
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        // ✅ 1. 클릭 이벤트 콜스택에서 즉시 팝업 생성
        let newWindow;
        if (isMobile) {
            newWindow = window.open(
                'about:blank', // 사파리에서 안전하게 팝업 유지
                '_blank',
                `width=${window.innerWidth},height=${window.innerHeight},left=0,top=0`
            );
        } else {
            const width = 500;
            const height = 700;
            const left = window.screenX + (window.outerWidth - width) / 2;
            const top = window.screenY + (window.outerHeight - height) / 2;

            newWindow = window.open(
                'about:blank',
                '_blank',
                `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`
            );
        }

        // ✅ 2. 팝업 차단 여부 체크
        const popupBlocked = !newWindow || typeof newWindow.closed === 'undefined';
        if (popupBlocked) {
            alert("사파리가 결제 팝업을 차단했습니다.\nSafari 설정 > 팝업 차단 해제를 해주시거나\n'결제창 열기' 버튼을 다시 눌러주세요.");
            return;
        }

        // ✅ 3. 팝업에 로딩 문구 표시 (UX 개선)
        newWindow.document.write('<p style="font:16px/1.4 -apple-system">결제창을 준비 중입니다...</p>');
        newWindow.document.close();

        // ✅ 4. 팝업 닫힘 감지
        const popupCheckInterval = setInterval(() => {
            if (newWindow.closed) {
                clearInterval(popupCheckInterval);
                onSubmitPaymentCheck(header, body);
            }
        }, 500);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_PG_API}/api/payment/request`,
                JSON.stringify(body),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: header?.Authorization ?? "",
                    },
                }
            );

            const tmp = response?.data;

            // 4. 성공 시 팝업 안에서 URL 이동
            if (tmp?.success && tmp?.paymentUrl) {
                newWindow.location.href = tmp.paymentUrl;
            } else {
                newWindow.close();
                setLoading(false);
                setIsSubmitting(false);
                setMessage({ msg: "결제실패" });
            }
        } catch (error) {
            console.error(error);
            newWindow.close();
            const apiMsg = error?.response?.data?.msg || error?.message;
            setMessage({ msg: apiMsg ? `오류: ${apiMsg}` : "결제 요청 중 오류가 발생했습니다." });
        }
    };

    const onSubmitPaymentCheck = async (header, body) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_PG_API + `/api/payment/status/${body?.tid ?? ""}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: header?.Authorization ?? "",
                    },
                }
            );

            let tmp = response?.data;
            if (tmp?.success) {
                // await onSubmitPaymentSave(tmp, listData, dataParam);
                navigate("/urlComplete", {
                    state: {
                        receipt: tmp,
                        listData, // 현재 컴포넌트의 리스트 상태
                    },
                    replace: false,
                });
            } else {
                setLoading(false);
                setIsSubmitting(false);
                setMessage({ msg: "결제실패" });
            }
        } catch (error) {
            console.error(error);

            setLoading(false);
            setIsSubmitting(false);
            // 서버가 에러 메시지를 내려주면 노출
            const apiMsg = error?.response?.data?.msg || error?.message;
            setMessage({ msg: apiMsg ? `오류: ${apiMsg}` : "결제 요청 중 오류가 발생했습니다." });
        } finally {
            setLoading(false);
            setIsSubmitting(false);
        }
    };

    const onSubmitPaymentSave = async (receipt, orderListData, orderDataParam) => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/url-pay/save",
                {
                    receipt,
                    listData: orderListData,
                    data: orderDataParam,
                },
                { withCredentials: true }
            );

            let tmp = response?.data;
        } catch (error) {
            console.error("결제 결과 저장 오류:", error);
        }
    };

    return (
        <>
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            <div style={{ marginTop: 0, minHeight: '100dvh', height: '100%', background: "#f3f5f7" }}>
                <div className="urlPayment-wrap">
                    {/* 배송지 */}
                    <section className="urlPayment-section">
                        <h2 className="urlPayment-title">배송지</h2>
                        <div className="urlPayment-card">
                            <div className="urlPayment-row">
                                <label className="urlPayment-label">구매자명</label>
                                <input
                                    name="BuyerName"
                                    className="urlPayment-input"
                                    placeholder="이름 입력"
                                    value={formData.BuyerName}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="urlPayment-row">
                                <label className="urlPayment-label">연락처</label>
                                <input
                                    name="BuyerHpTel_display"
                                    className="urlPayment-input"
                                    placeholder="010-0000-0000"
                                    value={phoneDisplayValue}
                                    onChange={handlePhoneChange}
                                />
                            </div>

                            {/* 주소 - 우편번호 + 검색 버튼 */}
                            <div className="urlPayment-row">
                                <label className="urlPayment-label">주소</label>
                                <div style={{ display: 'flex', gap: 8 }}>
                                    <input
                                        name="Postcode"
                                        className="urlPayment-input"
                                        placeholder="우편번호"
                                        value={formData.Postcode}
                                        onChange={handleChange}
                                        style={{ width: "100px" }}
                                    />
                                    <button
                                        type="button"
                                        className="urlPayment-btn"
                                        onClick={openAddressSearch}
                                        style={{
                                            flex: '0 0 auto',
                                            padding: '0px 10px',
                                            borderRadius: 8,
                                            border: '1px solid #222',
                                            background: '#111',
                                            color: '#fff',
                                            cursor: 'pointer',
                                            minWidth: 72
                                        }}
                                    >
                                        주소 검색
                                    </button>
                                </div>
                            </div>

                            {/* 주소 - 기본주소(참고항목 포함, 읽기전용) */}
                            <div className="urlPayment-row">
                                <label className="urlPayment-label"></label>
                                <input
                                    name="BaseAddr"
                                    className="urlPayment-input"
                                    placeholder="도로명/지번 주소"
                                    value={formData.BaseAddr + (formData.ExtraAddr ? ` ${formData.ExtraAddr}` : '')}
                                    onChange={(e) => {
                                        // 직접 수정 허용: ExtraAddr 분리는 유지
                                        setFormData((prev) => ({ ...prev, BaseAddr: e.target.value, ExtraAddr: "" }));
                                    }}
                                />
                            </div>

                            {/* 주소 - 상세주소(입력) */}
                            <div className="urlPayment-row">
                                <label className="urlPayment-label"></label>
                                <input
                                    ref={detailInputRef}
                                    name="DetailAddr"
                                    className="urlPayment-input"
                                    placeholder="상세주소 입력"
                                    value={formData.DetailAddr}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </section>

                    {/* 주문상품 */}
                    <section className="urlPayment-section">
                        <h2 className="urlPayment-title">주문상품</h2>

                        <div className="urlPayment-card card1">
                            <div className="urlPayment-orderHead">
                                <div className="urlPayment-store">
                                    {productData?.co_nm || formData.MerchantName || "가맹점"}
                                </div>
                                <div className="urlPayment-shipFee">
                                    {effectiveShippingFee === 0 ? "배송비 무료" : `배송비 ${fmt(effectiveShippingFee)}원`}
                                </div>
                            </div>

                            <div className="urlPayment-orderBody">
                                <div className="urlPayment-thumb">
                                    {productData?.main_image ? (
                                        <img src={getImageSrc(productData.main_image)} alt="" className="urlPayment-thumbImg" />
                                    ) : prodImg ? (
                                        <img src={prodImg} alt="" className="urlPayment-thumbImg" />
                                    ) : null}
                                </div>
                                <div className="urlPayment-info">
                                    <div className="urlPayment-prod">{formData.GoodsName || "상품명"}</div>

                                    {/* 옵션 선택 */}
                                    {productData?.options && productData.options.length > 0 && (
                                        <div className="urlPayment-optionSection">
                                            <div className="urlPayment-optionLabel">옵션 선택</div>
                                            <select
                                                className="urlPayment-optionSelect"
                                                value={selectedOption?.optionId || ""}
                                                onChange={(e) => {
                                                    const optionId = e.target.value;
                                                    const option = productData.options.find(opt => opt.optionId == optionId);
                                                    setSelectedOption(option);
                                                    
                                                    // 옵션 변경 시 가격 재계산 (free_shipping_min_amount 적용)
                                                    if (option) {
                                                        const basePrice = productData?.is_discount_active && productData?.discount_price 
                                                            ? Number(productData.discount_price) 
                                                            : Number(productData.price) || 0;
                                                        const optionPrice = Number(option.additionalPrice) || 0;
                                                        const productSubtotal = (basePrice + optionPrice) * selectedQuantity;
                                                        const minFreeShipping = Number(productData?.free_shipping_min_amount) || 0;
                                                        const baseShippingFee = Number(productData?.shipping_fee) || 0;
                                                        const shippingFee = (minFreeShipping === 0 || productSubtotal >= minFreeShipping) ? 0 : baseShippingFee;
                                                        const totalPrice = productSubtotal + shippingFee;
                                                        
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            Amt: String(totalPrice)
                                                        }));
                                                        setDisplayAmt(fmt(totalPrice));
                                                    }
                                                }}
                                            >
                                                {productData.options.map((option) => (
                                                    <option
                                                        key={option.optionId}
                                                        value={option.optionId}
                                                        disabled={(option.stockQuantity ?? 0) <= 0}
                                                    >
                                                        {option.optionName} 
                                                        {option.additionalPrice > 0 ? ` (+${fmt(option.additionalPrice)}원)` : ''}
                                                        {option.stockQuantity > 0 ? ` (재고: ${option.stockQuantity}개)` : ' (품절)'}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}

                                    {/* 수량 선택 */}
                                    <div className="urlPayment-quantitySection">
                                        <div className="urlPayment-quantityLabel">수량</div>
                                        <div className="urlPayment-quantityControls" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            marginTop: '4px'
                                        }}>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (selectedQuantity > 1) {
                                                        const newQty = selectedQuantity - 1;
                                                        setSelectedQuantity(newQty);
                                                        updatePrice(newQty);
                                                    }
                                                }}
                                                disabled={selectedQuantity <= 1}
                                                style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    border: '1px solid #d1d5db',
                                                    borderRadius: '6px',
                                                    background: selectedQuantity <= 1 ? '#f3f4f6' : '#fff',
                                                    color: selectedQuantity <= 1 ? '#9ca3af' : '#374151',
                                                    cursor: selectedQuantity <= 1 ? 'not-allowed' : 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '16px',
                                                    fontWeight: '500'
                                                }}
                                            >
                                                −
                                            </button>
                                            <div style={{
                                                minWidth: '40px',
                                                textAlign: 'center',
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                padding: '6px 8px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '6px',
                                                background: '#f9fafb'
                                            }}>
                                                {selectedQuantity}
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    const maxQty = selectedOption?.stockQuantity || 999;
                                                    if (selectedQuantity < maxQty) {
                                                        const newQty = selectedQuantity + 1;
                                                        setSelectedQuantity(newQty);
                                                        updatePrice(newQty);
                                                    }
                                                }}
                                                disabled={selectedQuantity >= (selectedOption?.stockQuantity || 999)}
                                                style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    border: '1px solid #d1d5db',
                                                    borderRadius: '6px',
                                                    background: selectedQuantity >= (selectedOption?.stockQuantity || 999) ? '#f3f4f6' : '#fff',
                                                    color: selectedQuantity >= (selectedOption?.stockQuantity || 999) ? '#9ca3af' : '#374151',
                                                    cursor: selectedQuantity >= (selectedOption?.stockQuantity || 999) ? 'not-allowed' : 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '16px',
                                                    fontWeight: '500'
                                                }}
                                            >
                                                +
                                            </button>
                                        </div>
                                        {selectedOption && (
                                            <div style={{
                                                fontSize: '12px',
                                                color: '#6b7280',
                                                marginTop: '4px'
                                            }}>
                                                최대 {selectedOption.stockQuantity}개까지 주문 가능
                                            </div>
                                        )}
                                    </div>

                                    {/* 가격 표시: 상품명 + 옵션명 = 금액 (옵션 항상 있음) */}
                                    {(() => {
                                        const baseUnitPrice = productData?.is_discount_active && productData?.discount_price
                                            ? Number(productData.discount_price)
                                            : Number(productData?.price) || 0;
                                        const optionUnitPrice = Number(selectedOption?.additionalPrice) || 0;
                                        const lineTotal = (baseUnitPrice + optionUnitPrice) * selectedQuantity;
                                        const productName = productData?.product_name || '상품';
                                        const optionName = selectedOption?.optionName || '';
                                        return (
                                            <div className="urlPayment-itemBar">
                                                <div className="urlPayment-itemLeft">
                                                    {productName}
                                                    {optionName && ` + ${optionName}`}
                                                    {' = '}
                                                </div>
                                                <div className="urlPayment-itemRight">
                                                    {productData?.is_discount_active && productData?.price && Number(productData.discount_price) !== Number(productData.price) && (
                                                        <span className="urlPayment-priceOld">
                                                            {fmt(Number(productData.price) * selectedQuantity)}원
                                                        </span>
                                                    )}
                                                    <span className="urlPayment-priceNow">
                                                        {fmt(lineTotal)}원
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })()}
                                </div>
                            </div>

                            {/* 총 주문금액(카드 내부에 이어붙임) */}
                            <div className="urlPayment-totalInline">
                                <span className="urlPayment-totalLabel">총 주문금액</span>
                                <b className="urlPayment-totalValue">{displayAmt || "0"}원</b>
                            </div>
                        </div>
                    </section>

                    {/* 결제수단 */}
                    <section className="urlPayment-section">
                        <h2 className="urlPayment-title">결제수단</h2>
                        <div className="urlPayment-card">
                            <div className="urlPayment-row">
                                <label className="urlPayment-label" style={{ width: "auto", minWidth: "90px", whiteSpace: "nowrap" }}>이메일</label>
                                <input
                                    name="BuyerEmail"
                                    className="urlPayment-input"
                                    placeholder="email@example.com"
                                    value={formData.BuyerEmail}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* PASS인증 결제일 때만 카드 정보 입력 */}
                            {paymentType === 'a' && (
                                <>
                                    <div className="urlPayment-row">
                                        <label className="urlPayment-label" style={{ width: "auto", minWidth: "90px", whiteSpace: "nowrap" }}>카드번호</label>
                                        <div style={{ 
                                            display: "flex", 
                                            gap: "4px", 
                                            flex: 1,
                                            minWidth: 0
                                        }}>
                                            <input
                                                type="text"
                                                className="urlPayment-input"
                                                placeholder="0000"
                                                maxLength={4}
                                                value={cardNum1}
                                                onChange={handleCardInput1}
                                                style={{ 
                                                    flex: "1",
                                                    fontSize: "14px",
                                                    padding: "8px 4px",
                                                    textAlign: "center",
                                                    minWidth: 0
                                                }}
                                            />
                                            <input
                                                ref={cardNum2Ref}
                                                type="text"
                                                className="urlPayment-input"
                                                placeholder="0000"
                                                maxLength={4}
                                                value={cardNum2}
                                                onChange={handleCardInput2}
                                                style={{ 
                                                    flex: "1",
                                                    fontSize: "14px",
                                                    padding: "8px 4px",
                                                    textAlign: "center",
                                                    minWidth: 0
                                                }}
                                            />
                                            <input
                                                ref={cardNum3Ref}
                                                type="text"
                                                className="urlPayment-input"
                                                placeholder="0000"
                                                maxLength={4}
                                                value={cardNum3}
                                                onChange={handleCardInput3}
                                                style={{ 
                                                    flex: "1",
                                                    fontSize: "14px",
                                                    padding: "8px 4px",
                                                    textAlign: "center",
                                                    minWidth: 0
                                                }}
                                            />
                                            <input
                                                ref={cardNum4Ref}
                                                type="text"
                                                className="urlPayment-input"
                                                placeholder="0000"
                                                maxLength={4}
                                                value={cardNum4}
                                                onChange={handleCardInput4}
                                                style={{ 
                                                    flex: "1",
                                                    fontSize: "14px",
                                                    padding: "8px 4px",
                                                    textAlign: "center",
                                                    minWidth: 0
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="urlPayment-row">
                                        <label className="urlPayment-label" style={{ width: "auto", minWidth: "90px", whiteSpace: "nowrap" }}>유효기간</label>
                                        <div style={{ display: "flex", gap: "8px", flex: 1, alignItems: "center", minWidth: 0 }}>
                                            <input
                                                type="text"
                                                name="ExpYear"
                                                className="urlPayment-input"
                                                placeholder="YY"
                                                maxLength={2}
                                                value={formData.ExpYear}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, "").slice(0, 2);
                                                    setFormData((prev) => ({ ...prev, ExpYear: value }));
                                                    if (value.length === 2) {
                                                        document.querySelector('input[name="ExpMonth"]')?.focus();
                                                    }
                                                }}
                                                style={{ 
                                                    flex: 1, 
                                                    fontSize: "16px",
                                                    textAlign: "center",
                                                    minWidth: 0
                                                }}
                                            />
                                            <span style={{ fontSize: "16px", color: "var(--muted)", flexShrink: 0 }}>/</span>
                                            <input
                                                type="text"
                                                name="ExpMonth"
                                                className="urlPayment-input"
                                                placeholder="MM"
                                                maxLength={2}
                                                value={formData.ExpMonth}
                                                onChange={(e) => {
                                                    let value = e.target.value.replace(/\D/g, "");
                                                    // 01-12 범위 체크
                                                    if (value.length === 2) {
                                                        const month = parseInt(value);
                                                        if (month < 1 || month > 12) {
                                                            value = value.slice(0, 1);
                                                        }
                                                    }
                                                    setFormData((prev) => ({ ...prev, ExpMonth: value.slice(0, 2) }));
                                                }}
                                                style={{ 
                                                    flex: 1, 
                                                    fontSize: "16px",
                                                    textAlign: "center",
                                                    minWidth: 0
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="urlPayment-row">
                                        <label className="urlPayment-label" style={{ width: "auto", minWidth: "90px", whiteSpace: "nowrap" }}>CVV / 비밀번호</label>
                                        <div style={{ display: "flex", gap: "8px", flex: 1, minWidth: 0 }}>
                                            <input
                                                name="CardCvv"
                                                type="password"
                                                className="urlPayment-input urlPayment-input-small-placeholder"
                                                placeholder="카드 뒷면 3자리"
                                                maxLength={3}
                                                value={formData.CardCvv}
                                                onChange={handleChange}
                                                style={{ flex: 1, fontSize: "16px", minWidth: 0 }}
                                            />
                                            <input
                                                name="CardPw"
                                                type="password"
                                                className="urlPayment-input urlPayment-input-small-placeholder"
                                                placeholder="앞 2자리"
                                                maxLength={2}
                                                value={formData.CardPw}
                                                onChange={handleChange}
                                                style={{ flex: 1, fontSize: "16px", minWidth: 0 }}
                                            />
                                        </div>
                                    </div>

                                    <div className="urlPayment-row">
                                        <label className="urlPayment-label" style={{ width: "auto", minWidth: "90px", whiteSpace: "nowrap" }}>할부 개월</label>
                                        <select
                                            name="CardQuota"
                                            className="urlPayment-select"
                                            value={formData.CardQuota}
                                            onChange={handleChange}
                                            style={{ fontSize: "16px" }}
                                        >
                                            <option value="00">일시불</option>
                                            <option value="02">2개월</option>
                                            <option value="03">3개월</option>
                                            <option value="04">4개월</option>
                                            <option value="05">5개월</option>
                                        </select>
                                    </div>
                                </>
                            )}
                        </div>
                    </section>

                    {/* 현금영수증 */}
                    <section className="urlPayment-section">
                        <h2 className="urlPayment-title">현금영수증</h2>
                        <div className="urlPayment-card">
                            <div className="urlPayment-row">
                                <label className="urlPayment-label">발급 여부</label>
                                <select
                                    name="CashReceiptType"
                                    className="urlPayment-select"
                                    value={formData.CashReceiptType}
                                    onChange={handleChange}
                                >
                                    <option value="0">발급안함</option>
                                    <option value="1">소득공제용 발급</option>
                                </select>
                            </div>

                            {formData.CashReceiptType === "1" && (
                                <div className="urlPayment-row">
                                    <label className="urlPayment-label">발행정보</label>
                                    <input
                                        name="CashReceiptInfo"
                                        className="urlPayment-input"
                                        placeholder="전화번호/사업자번호"
                                        value={formData.CashReceiptInfo}
                                        onChange={handleChange}
                                    />
                                </div>
                            )}
                        </div>
                    </section>

                    {/* PASS인증 결제 안내 카드 */}
                    {paymentType === 'a' && (
                        <div style={{
                            backgroundColor: '#e3f2fd',
                            border: '1px solid #2196f3',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            margin: '16px 0',
                            fontSize: '14px',
                            color: '#1976d2'
                        }}>
                            <strong>PASS인증 결제</strong><br/>
                            본인인증을 통해 안전하게 결제하실 수 있습니다.
                        </div>
                    )}

                    {/* 하단 버튼 공간 확보 */}
                    <div className="urlPayment-bottomPad" />
                </div>

                {/* 하단 고정 버튼: "{금액}원 결제하기" */}
                <div className="urlPayment-buybar">
                    <button
                        className="urlPayment-buyBtn"
                        onClick={onSubmitPayment}
                        disabled={isDisabled}
                    >
                        {isSubmitting ? "결제중..." : 
                         paymentType === 'a' ? 
                         `${displayAmt || "0"}원 PASS인증 결제하기` : 
                         `${displayAmt || "0"}원 결제하기`}
                    </button>
                </div>
            </div>

            {/* ===== 주소검색 모달 ===== */}
            {/* ===== 주소검색 모달 ===== */}
            {addrOpen && (
                <div
                    onClick={() => setAddrOpen(false)}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0,0,0,0.45)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        padding: 16,
                        overflow: 'hidden', // 바깥 스크롤 잠금
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            width: 'min(720px, 100%)',
                            maxHeight: '90vh',
                            background: '#fff',
                            borderRadius: 12,
                            boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden',
                        }}
                    >
                        {/* 헤더(닫기 버튼 포함) */}
                        <div style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            padding: '10px 12px', borderBottom: '1px solid #eee', position: 'sticky', top: 0, background: '#fff', zIndex: 1
                        }}>
                            <b>주소 검색</b>
                            <button
                                onClick={() => setAddrOpen(false)}
                                style={{ border: 'none', background: '#000', color: '#fff', borderRadius: 8, padding: '6px 10px', cursor: 'pointer' }}
                            >
                                닫기
                            </button>
                        </div>

                        {/* 스크롤되는 바디 */}
                        <div
                            ref={modalBodyRef}
                            style={{
                                flex: '1 1 auto',
                                overflowY: 'auto',
                                WebkitOverflowScrolling: 'touch',
                                overscrollBehavior: 'contain',
                            }}
                        >
                            {/* 우편번호 컴포넌트가 박히는 래퍼 */}
                            <div ref={addrLayerRef} style={{ width: '100%', height: '100%', minHeight: 420 }} />
                        </div>
                    </div>
                </div>
            )}

        </>
    );
}

export default UrlPayment;
